exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{font-family:Georgia,serif;background-color:#161616;color:#fff}h1,h2,h3,h4,h5,h6{font-family:Trebuchet MS,Helvetica,sans-serif;font-weight:700;color:#926f41}.show{display:block}.hide{display:none}.standard-section{min-height:400px;padding:40px;position:relative}@media (max-width:575.98px){.standard-section{padding:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/index.scss
// module id = 165
// module chunks = 0